module.exports = __webpack_public_path__ + "img/aboutus_ceftification.20edf794.png";